import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { UIMessages } from '../../useChatView';
import { useTranslate } from '@tolgee/react';
import dayjs from 'lib/dayjs';
import { Button } from 'antd';
import { useMemoizedFn } from 'ahooks';
import { memo } from 'react';

interface SysRecallMsgProps extends BaseSysMsgProps {
  msg: UIMessages;
  onClick: (conversationId: string, recallText: string) => void;
}

export const SysRecallMsg = memo((props: SysRecallMsgProps) => {
  const { raw, msg, conversation, onClick } = props;
  const { msgFromType } = raw;
  const { type, time } = msg;
  const { conversationId } = conversation;
  const { t } = useTranslate();

  const enableEdit = dayjs().isBefore(dayjs(time).add(10, 'minutes'));
  const recallText = msg?.raw.textContent?.originalText || msg?.raw.textContent?.text || '';

  const handleClick = useMemoizedFn(() => {
    onClick(conversationId, recallText);
  });

  if (msgFromType === 'BUYER') {
    return <SystemMessage>{t('ViewsChat.对方已撤回一条消息')}</SystemMessage>;
  }

  if (type === 'text' && recallText && enableEdit) {
    return (
      <SystemMessage>
        {t('ViewsChat.您已撤回一条消息')}
        <Button size="small" type="link" onClick={handleClick}>
          {t('ViewsChat.重新编辑')}
        </Button>
      </SystemMessage>
    );
  }

  return <SystemMessage>{t('ViewsChat.您已撤回一条消息')}</SystemMessage>;
});
